import Api from "@/services/api";
import Vue from "vue";

export default {
    namespaced: true,
    actions: {
        async getStatus() {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().get(`/ValidateIq/status`, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async getUsage() {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().get(`/ValidateIq/usage`, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async getConnectUrl({}, returnUrl) {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` },
                params: {
                    returnUrl: returnUrl
                }
            };

            let response = await Api().get(`/ValidateIq/connect`, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async getPhoneFormatting() {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().get(`/ValidateIq/phone-formatting`, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async savePhoneFormatting({}, phoneFormatting) {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().post(`/ValidateIq/phone-formatting`, phoneFormatting, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async getPhoneProperties() {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().get(`/ValidateIq/phone-properties`, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async savePhoneProperties({}, phoneProperties) {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().post(`/ValidateIq/phone-properties`, phoneProperties, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async getAvailablePhoneProperties() {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().get(`/ValidateIq/phone-properties/available`, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async getLiveSync() {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().get(`/ValidateIq/live-sync`, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async setLiveSync({}, enabled) {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().post(`/ValidateIq/live-sync`, { enabled }, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async syncProperties() {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().post(`/ValidateIq/properties/sync`, {}, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async validateContact({}, { hsContactId, phoneFormatting }) {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().post(`/ValidateIq/contacts/${encodeURIComponent(hsContactId)}/validate`, phoneFormatting, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async validateAllContacts({}, phoneFormatting) {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().post(`/ValidateIq/contacts/validate-all`, phoneFormatting, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async getSyncDashboard({}, take) {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` },
                params: {
                    take: take
                }
            };

            let response = await Api().get(`/ValidateIq/contacts/sync-all/dashboard`, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async getSegments() {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().get(`/ValidateIq/segments`, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async validateSegmentContacts({}, { listId, phoneFormatting }) {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().post(`/ValidateIq/segments/${encodeURIComponent(listId)}/validate`, phoneFormatting, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async getEstimate({}, { scope, hubSpotListId }) {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().post(`/ValidateIq/contacts/estimate`, { scope, hubSpotListId }, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async getBillingPlans() {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().get(`/ValidateIq/billing/plans`, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async purchaseValidations({}, { validations, autoRenew }) {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().post(`/ValidateIq/billing/purchase`, { validations, autoRenew }, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async setAutoRenew({}, { enabled, validations }) {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().post(`/ValidateIq/billing/auto-renew`, { enabled, validations }, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async updatePaymentMethod() {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };

            let response = await Api().post(`/ValidateIq/billing/payment-method`, {}, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        },
        async getInvoices({}, { page = 1, pageSize = 10 } = {}) {
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` },
                params: { page, pageSize }
            };

            let response = await Api().get(`/ValidateIq/billing/invoices`, config).catch(err => {
                console.error(err.message);
                return err.response;
            });

            return response;
        }
    }
}

